import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { POSICION_DEUDOR_WRITE } from "helpers/profilePermission";
import isUserHasProfile from "helpers/profileValidator";
import { API, BASE_URL } from '../../../CONST';
import { get } from '../../../helpers/requests';
import PosicionDeudorInfo from './posicionDeudorInfo';
import PosicionDeudorEdit from './posicionDeudorEdit';
import PosicionDeudorInternalInfo from './posicionDeudorInternalInfo';
import PosicionDeudorInfoTable from './posicionDeudorInfoTable';
import PosicionDeudorTable from './posicionDeudorTable';
import PageContainer from '../../PageContainer';
import BalanceCreditoContext from './balanceCreditoContext';

const PosicionDeudor = () => {
  const { id } = useParams();
  const [infoDeudorData, setInfoDeudorData] = useState({});
  const [scoreDataByMov, setScoreDataByMov] = useState({});
  const [edit, setEdit] = useState(false);
  const [balanceCreditoData, setBalanceCreditoData] = useState([]);
  const [deudorIsForeign, setDeudorIsForeign] = useState(false);
  const [monedaAsegurada, setMonedaAsegurada] = useState('UF');

  useEffect(() => {
    get(`${BASE_URL}${API.deudor}/${id}/`).then((response) => {
      setInfoDeudorData(response);

      setDeudorIsForeign(response.pais && response.pais.code !== 'CL');
    });
  }, [id, edit]);

  useEffect(() => {
    if (!infoDeudorData?.rut) return;
    
    get(`${BASE_URL}${API.clasificacionesdirect}/?rut=${infoDeudorData.rut}&type=1`)
      .then(response => {
        if (response && response.length > 0 && response[0].data) {
          setScoreDataByMov(
            response.reduce((acc, current) => {
              acc[current.reporte_consolidado_id] = current;
              return acc;
            }, {}),
          );
        }
      })
      .catch(error => {
        console.error('Error al obtener score:', error);
      });
  }, [infoDeudorData]);

  useEffect(() => {
    // Antes de que cargue el balance, se utiliza UF o USD dependiendo de si el deudor es extranjero
    // Una vez cargue balance, se utiliza la moneda asegurada del primer movimiento
    if (!!balanceCreditoData?.data && balanceCreditoData.data.length > 0) {
      setMonedaAsegurada(balanceCreditoData.data[0].moneda_asegurada);
    } else {
      setMonedaAsegurada(deudorIsForeign ? 'USD' : 'UF');
    }
  }, [balanceCreditoData, deudorIsForeign]);

  const toggleModal = (event) => {
    if (event) {
      event.preventDefault();
    }
    setEdit(!edit);
  };

  return (
    <BalanceCreditoContext.Provider value={{ balanceCreditoData, setBalanceCreditoData }}>
      <PageContainer
        breadcrumbs={[
          { id: 1, name: 'RIESGO DE CREDITO', url: '/' },
          { id: 2, name: 'POSICIÓN DEL DEUDOR', url: '/posicion-deudor' },
          { id: 3, name: id },
        ]}
        mainAction={
          isUserHasProfile(POSICION_DEUDOR_WRITE) && {
            url: '/',
            onClick: toggleModal,
            caption: 'Editar deudor',
          }
        }
      >
        <Col>
          <Row>
            <Col>
              <PosicionDeudorInfo datos={infoDeudorData} />
            </Col>
            <Col>
              <PosicionDeudorInfoTable 
                datos={infoDeudorData} 
                monedaAsegurada={monedaAsegurada} 
                modalCerrado={!edit} 
              />
              <PosicionDeudorInternalInfo 
                datos={infoDeudorData} 
                deudorIsForeign={deudorIsForeign}
                modalCerrado={!edit} 
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <PosicionDeudorTable
                id={id}
                edit={edit}
                datosDeudor={infoDeudorData}
                isForeign={deudorIsForeign}
                datosScoreByMov={scoreDataByMov}
                monedaAsegurada={monedaAsegurada}
              />
            </Col>
          </Row>
        </Col>
        <PosicionDeudorEdit
          openModal={edit}
          id={id}
          toggleModal={toggleModal}
          datos={infoDeudorData}
          deudorIsForeign={deudorIsForeign}
          monedaAsegurada={monedaAsegurada}
        />
      </PageContainer>
    </BalanceCreditoContext.Provider>
  );
};

export default PosicionDeudor;
